import { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import Button from "../../../ui/Button";
import DOMPurify from "dompurify";
import styles from "../../../layout/admin/Main.module.scss";
import CoAppDataStyles from "./CourseApplicantDataTable.module.scss";
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";
import {
  getCourse,
  getCourseApplicantList,
  postUpdateBrkCourseApplicantList,
} from "../../../../services/apiCourseApplicant";
import Detail from "./Detail";
import CourseApplicantSearchFrom from "./CourseApplicantSearchFrom";
import CourseApplicantDataTable from "./CourseApplicantDataTable";
import LotteryModal from "./LotteryModal";
import Form from "../../../ui/Form";
import CSVDownloader from "../../../ui/CSVDownloader";
import Loading from "../../../../components/ui/Loading";
import Progress from "../../../../components/ui/Progress";
import { getCodeMasterList } from "../../../../services/apiCodeMaster";
import { useAuth } from "../../../../contexts/AuthContext";
import { AUTH_SHIBUYA, AUTH_UNIVERSITY } from "../../../../utils/config";
import { getCsvJson } from "../../../../utils/csvJson";
import { getImageUrlStr } from "../../../../utils/courseData";
import { calcEndOfYearAge } from "../../../../utils/calcAge";

const csvItems = {
  course_id: "講座ID",
  course_name: "講座名",
  content: "講座内容",
  organ: "実施機関",
  univ_id: "大学ID",
  period_f: "申込期間(FROM)",
  period_t: "申込期間(TO)",
  period: "講座開催日・講座時間(※テキスト)",
  all_times: "全回数(※テキスト)",
  tuition_fee: "受講料",
  venue: "会場",
  unit: "単位/1回出席あたり",
  tuition_fee1: "受講料/1回あたり",
  material_cost: "材料費",
  category: "講座カテゴリ",
  image: "画像URL",
  status: "公開・非公開フラグ",
  keyword: "検索キーワード",
  course_applicant_id: "申込者ID",
  lottery_status_text: "当選・落選フラグ",
  login_id: "学生番号(8桁)",
  name: "氏名",
  name_kana: "フリガナ",
  postcode: "郵便番号",
  pref: "都道府県",
  street_name1: "町名(自動表示)",
  street_name2: "丁名(自動表示)",
  address: "番地・号",
  street_name3: "方書き",
  birthday: "生年月日",
  age: "年齢(年度末時点)",
  gender: "性別(男性・女性)",
  phone1: "電話番号1",
  mail1: "メールアドレス1",
  phone2: "電話番号2",
  mail2: "メールアドレス2",
  emergency_name: "緊急連絡先(氏名)",
  emergency_emereletion: "緊急連絡先(続柄)",
  emergency_phone: "緊急連絡先(電話番号)",
  acquisition_unit: "取得単位数",
  aid_tuition_fee: "補助対象受講料",
  attendance1_text: "1回目",
  attendance2_text: "2回目",
  attendance3_text: "3回目",
  attendance4_text: "4回目",
  attendance5_text: "5回目",
  attendance6_text: "6回目",
  attendance7_text: "7回目",
  attendance8_text: "8回目",
  attendance9_text: "9回目",
  attendance10_text: "10回目",
  attendance11_text: "11回目",
  attendance12_text: "12回目",
  attendance13_text: "13回目",
  attendance14_text: "14回目",
  attendance15_text: "15回目",
  attendance_status_text: "未受講・受講中・受講済み",
  how_apply: "申込方法",
  is_student: "学生or一般",
  is_cancel: "キャンセルフラグ",
  remarks: "備考",
  is_email: "メール配信フラグ",
  is_open_applicant: "公開フラグ(申込者)",
  capacity: "定員",
  permalink: "記事URL",
  attendance_updated_date: "出欠情報更新日時",
  is_wheelchair_text: "車いす",
};

const CourseDetail = () => {
  // ユーザー情報
  const { user } = useAuth();
  // 講座ID(サイトID + 講座ID 8桁)
  const { id } = useParams();
  // 画面表示モード
  const { type } = useParams();
  // 講座詳細データ
  const [detalData, setDetailData] = useState([]);
  // 画面表示モード(1:講座詳細 2:申込者一覧)
  const [displayType, setDisplayType] = useState(Number(type));
  // 検索条件
  const [searchCondition, setSearchCondition] = useState({});
  // 一覧データ
  const [tableData, setTableData] = useState([]);
  // 表示ページ
  const [currentPage, setCurrentPage] = useState(1);
  // 抽選モーダル表示ステータス
  const [showLotteryModalFlag, setShowLotteryModalFlag] = useState(false);
  // 再レンダリングステータス
  const [reloadFlag, setReloadFlag] = useState(true);
  // 各ドロップダウンリスト
  const [lotteryStatus, setLotteryStatus] = useState([]);
  const [attendanceStatus, setAttendanceStatus] = useState([]);
  const [attendance, setAttendance] = useState([]);
  // CSVダウンロード用データ
  const [csvData, setCsvData] = useState({});
  // ローディング表示
  const [loading, setLoading] = useState(false);
  // ヘッダーのチェックボックスuseRef
  const headerCkRef = useRef(null);
  // チェックボックスuseRef
  const recordCkRefs = useRef([]);
  // 当選状況useRef
  const recordLsRefs = useRef([]);
  // 未受講・受講中・受講済みuseRef
  const recordAsRefs = useRef([]);
  // 取得単位数useRef
  const recordAuRefs = useRef([]);
  // 出席情報更新フラグ値useRef
  const recordUaRefs = useRef([]);
  // 出席情報useRef
  const recordAdRefs = useRef([]);
  // navigate
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  // 表示モード(講座詳細/申込者一覧)
  useEffect(() => {
    // パラメータチェック
    if (displayType == 1 || displayType == 2) {
      let data = {};
      (async function () {
        // ローディング表示開始
        setLoading(true);
        data = await getCourse({ id });
        if (data == undefined || !data) return;
        // 権限確認
        if (user.authority == AUTH_UNIVERSITY) {
          if (!user.university_id == data.univ_id) {
            navigate("/admin/404");
          }
        }
        if (displayType == 1) {
          // 講座詳細画面
          // 講座詳細データセット
          if (Object.keys(data).length === 0) {
            navigate("/admin/404");
          }
          setDetailData(data);
        } else if (displayType == 2) {
          // 申込者一覧画面
          // 講座詳細データセット（period_calendarなどを使用するため）
          if (Object.keys(data).length === 0) {
            navigate("/admin/404");
          }
          setDetailData(data);

          // リストデータの選択肢データセット
          const lsData = await getCodeMasterList({ code: "CD003" });
          setLotteryStatus(
            lsData.map((d) => {
              return { label: d.d_text, value: d.d_value };
            }),
          );

          const asData = await getCodeMasterList({ code: "CD004" });
          setAttendanceStatus(
            asData.map((d) => {
              return { label: d.d_text, value: d.d_value };
            }),
          );

          const aData = await getCodeMasterList({ code: "CD006" });
          setAttendance(
            aData.map((d) => {
              return { label: d.d_text, value: d.d_value };
            }),
          );
        }
        // ローディング表示終了
        setLoading(false);
      })();
    } else {
      navigate("/admin/404");
    }
  }, [displayType]);

  // 検索条件,再レンダリングフラグ
  useEffect(() => {
    (async function () {
      // 申込者一覧画面でない場合はなにもせずにreturn
      if (displayType != 2) return;
      // 再レンダリングフラグがFalseの場合はなにもせずにreturn
      if (!reloadFlag) return;
      // ローディング表示開始
      setLoading(true);
      setCurrentPage(1);
      const data = await getCourseApplicantList({ id: id }, searchCondition);
      if (!data) return;
      // 一覧データ
      setTableData(
        data.map((d) => {
          return {
            key: d.login_id,
            student_id: d.student_id,
            login_id: d.login_id,
            name_link: (
              <Link
                to={
                  "/admin/course/detail/applicant/" +
                  d.course_id +
                  "/" +
                  d.user_id
                }
              >
                {d.is_wheelchair ? `【車いす】${d.name}` : d.name}
              </Link>
            ),
            name_kana: d.name_kana,
            lottery_status: d.lottery_status,
            how_apply: d.how_apply,
            attendance_status: d.attendance_status,
            attendance_updated_date: d.attendance_updated_date,
            acquisition_unit: d.acquisition_unit,
            attendance1: d.attendance1,
            attendance2: d.attendance2,
            attendance3: d.attendance3,
            attendance4: d.attendance4,
            attendance5: d.attendance5,
            attendance6: d.attendance6,
            attendance7: d.attendance7,
            attendance8: d.attendance8,
            attendance9: d.attendance9,
            attendance10: d.attendance10,
            attendance11: d.attendance11,
            attendance12: d.attendance12,
            attendance13: d.attendance13,
            attendance14: d.attendance14,
            attendance15: d.attendance15,
            updated_at: d.updated_at,
          };
        }),
      );

      // CSVダウンロード用データ(渋谷区/大学共通)
      setCsvData(
        data.map((d) => {
          // データ加工
          d = setAge(procImage(procContent(d)));
          return getCsvJson(csvItems, d);
        }),
      );
      // ローディング表示終了
      setLoading(false);
    })();
    // 初期値をとってくる
  }, [searchCondition, reloadFlag]);

  /**
   * 誕生日から年度末年齢計算(CSVダウンロード用)
   * @param {string} birthday_val
   * @returns {string}
   */
  const calcAge = (birthday_val) => {
    // 生年月日入力値
    if (!birthday_val) {
      return "";
    }
    const eofy_age = calcEndOfYearAge(birthday_val);

    return String(eofy_age) + "歳";
  };

  /**
   * 講座詳細加工(CSVダウンロード用)
   * @param {object} d
   * @returns {object}
   */
  const procContent = (d) => {
    if (typeof d.content !== "undefined") {
      d.content = DOMPurify.sanitize(d.content, {
        ALLOWED_TAGS: [],
      });
    }
    return d;
  };

  /**
   * 画像URL加工(CSVダウンロード用)
   * @param {object} d
   * @returns {object}
   */
  const procImage = (d) => {
    if (typeof d.image !== "undefined") {
      d.image = getImageUrlStr(d.image);
    }
    return d;
  };

  /**
   * 年齢セット(CSVダウンロード用)
   * @param {object} d
   * @returns {object}
   */
  const setAge = (d) => {
    if (typeof d.age !== "undefined" && typeof d.birthday !== "undefined") {
      d.age = calcAge(d.birthday);
    }
    return d;
  };

  // 画面表示モード変更
  const changeDisplayType = (type) => {
    // 画面表示モード変更
    setDisplayType(type);
    // 初期検索条件で一覧データを取得
    setSearchCondition({});
  };

  // 講座申込詳細表示
  const returnDetail = (type) => {
    if (type == 1) {
      // 講座詳細
      return <Detail courseData={detalData} />;
    }
  };

  // 追加登録する(新規講座申込)ボタン表示
  const returnAddCourseApplicant = (type) => {
    if (type == 2) {
      return (
        <>
          {user.authority == AUTH_SHIBUYA ? (
            <div>
              <SubScreenTitle>申込者追加登録</SubScreenTitle>
              <Link to={"/admin/course/detail/add/" + id}>
                <Button styleType="new">追加登録する</Button>
              </Link>
            </div>
          ) : (
            <></>
          )}
        </>
      );
    }
  };

  // 申込者一覧-検索フォーム表示
  const returnSearchForm = (type) => {
    if (type == 2) {
      // 申込者一覧-検索フォーム表示
      return (
        <CourseApplicantSearchFrom
          resetUpdateData={resetUpdateData}
          setSearchCondition={setSearchCondition}
          authority={user.authority}
          period={detalData.period_calendar}
        />
      );
    }
  };

  // 申込者一覧-データ一覧/ボタン表示エリア表示
  const returnDataTable = (type) => {
    if (type == 2) {
      // 申込者一覧-データ一覧表示
      return (
        <div>
          <Form onSubmitHandler={handleSubmit(onSubmit)}>
            <div hidden>
              <input
                type="text"
                name="course_id"
                value={id}
                {...register("course_id", {})}
              ></input>
            </div>
            <CourseApplicantDataTable
              lotteryStatus={lotteryStatus}
              attendanceStatus={attendanceStatus}
              attendance={attendance}
              tableData={tableData}
              register={register}
              setValue={setValue}
              errors={errors}
              authority={user.authority}
              headerCkRef={headerCkRef}
              recordCkRefs={recordCkRefs}
              recordLsRefs={recordLsRefs}
              recordAsRefs={recordAsRefs}
              recordAuRefs={recordAuRefs}
              recordUaRefs={recordUaRefs}
              recordAdRefs={recordAdRefs}
              resetUpdateData={resetUpdateData}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
            <div className={styles.buttonbox__left}>
              {user.authority == AUTH_SHIBUYA ? (
                <Button
                  type="button"
                  styleType="new"
                  onClick={() => showLotteryModal()}
                >
                  抽選する
                </Button>
              ) : (
                <></>
              )}
              <Button type="submit" styleType="new">
                更新
              </Button>
              <Button
                type="button"
                styleType="new"
                onClick={() => resetUpdateData()}
              >
                リセット
              </Button>
            </div>
          </Form>
          <div className={styles.buttonbox__left}>
            <CSVDownloader
              data={csvData}
              filenameprefix="申込者一覧"
              buttonname="ダウンロード"
            />
          </div>
          <LotteryModal
            course_id={id}
            showFlag={showLotteryModalFlag}
            setShowModal={setShowLotteryModalFlag}
            setReloadFlag={setReloadFlag}
            key={showLotteryModalFlag}
          />
        </div>
      );
    }
  };

  // 抽選モーダル表示
  const showLotteryModal = () => {
    setShowLotteryModalFlag(true);
  };

  // 一括更新
  async function onSubmit(data) {
    // 一括更新処理
    const json = await postUpdateBrkCourseApplicantList(data);
    if (json) {
      alert("更新完了");
      // 申込者一覧画面を再描画
      const nurl = new URL(window.location.href);
      window.location.href = nurl.origin + "/admin/course/detail/" + id + "/2";
    }
  }

  // リセット
  const resetUpdateData = () => {
    // ヘッダーチェックボックス
    headerCkRef.current.checked = false;
    // レコードごとのチェックボックス
    recordCkRefs.current.map((ref, index) => {
      if (ref != null && ref.current != null) {
        // チェックを外す
        ref.current.checked = false;
        // valueにfalseをセット
        setValue("is_update_attendance_" + index, false);
      }
    });
    // 当選状況
    recordLsRefs.current.map((ref, index) => {
      if (ref != null && ref.current != null) {
        // 対象のフィールドが変更されているか
        if (ref.current.className.includes(CoAppDataStyles.is_change)) {
          // 背景色を戻す
          ref.current.className = ref.current.className.replace(
            CoAppDataStyles.is_change,
            "",
          );
          // 値を変更前に戻す
          setValue(
            "lottery_status_" + index,
            ref.current.attributes["bkvalue"].nodeValue,
          );
        }
      }
    });
    // 未受講・受講中・受講済み
    recordAsRefs.current.map((ref, index) => {
      if (ref != null && ref.current != null) {
        // 対象のフィールドが変更されているか
        if (ref.current.className.includes(CoAppDataStyles.is_change)) {
          // 背景色を戻す
          ref.current.className = ref.current.className.replace(
            CoAppDataStyles.is_change,
            "",
          );
          // 値を変更前に戻す
          setValue(
            "attendance_status_" + index,
            ref.current.attributes["bkvalue"].nodeValue,
          );
        }
      }
    });
    // 取得単位数
    recordAuRefs.current.map((ref, index) => {
      if (ref != null && ref.current != null) {
        // 対象のフィールドが変更されているか
        if (ref.current.className.includes(CoAppDataStyles.is_change)) {
          // 背景色を戻す
          ref.current.className = ref.current.className.replace(
            CoAppDataStyles.is_change,
            "",
          );
          // 値を変更前に戻す
          setValue(
            "acquisition_unit_" + index,
            ref.current.attributes["bkvalue"].nodeValue,
          );
        }
      }
    });
    // 出席情報
    recordAdRefs.current.map((ref, index) => {
      // 出席情報更新フラグにfalseをセット
      setValue("is_update_attendance_" + index, false);
      if (ref != null) {
        Array.from({ length: 15 }).map((_, i) => {
          if (ref[i] != null && ref[i].current != null) {
            // 対象のフィールドが変更されているか
            if (ref[i].current.className.includes(CoAppDataStyles.is_change)) {
              // 背景色を戻す
              ref[i].current.className = ref[i].current.className.replace(
                CoAppDataStyles.is_change,
                "",
              );
              // 値を変更前に戻す
              setValue(
                "attendance_" + index + "_" + (i + 1),
                ref[i].current.attributes["bkvalue"].nodeValue,
              );
            }
          }
        });
      }
    });
  };

  return (
    <div className={styles.main} key={1}>
      <ScreenTitle>講座管理</ScreenTitle>
      <SubScreenTitle>講座詳細</SubScreenTitle>
      <div className={styles.buttonbox__tab}>
        <Button
          type="button"
          styleType={displayType === 1 ? "tab_active" : "tab"}
          onClick={() => changeDisplayType(1)}
        >
          講座詳細
        </Button>
        <Button
          type="button"
          styleType={displayType === 2 ? "tab_active" : "tab"}
          onClick={() => changeDisplayType(2)}
        >
          申込者一覧
        </Button>
      </div>
      {returnDetail(displayType)}
      {returnAddCourseApplicant(displayType)}
      {returnSearchForm(displayType)}
      {returnDataTable(displayType)}
      <div className={styles.buttonbox}>
        <Link className={styles.link} to="/admin/course">
          講座管理へ戻る
        </Link>
      </div>
      <div className={styles.buttonbox}>
        <Link className={styles.link} to="/admin/top">
          トップページへ戻る
        </Link>
      </div>
      {loading ? <Loading /> : <></>}
      {loading ? <Progress /> : <></>}
    </div>
  );
};

export default CourseDetail;
